module.exports = __webpack_public_path__ + "img/no-image.038249d3.png";